import api from "../..";
import type { Skyroom, GetSkyroomParams, GetSkyroomsParams } from "./types";

export const getSkyrooms = async ({ params }: GetSkyroomsParams = {}): Promise<Skyroom[]> => {

  const queryParams = new URLSearchParams();

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (Array.isArray(value)) {
          value.forEach((item) => queryParams.append(key, item.toString()));
        } else {
          queryParams.set(key, value.toString());
        }
      }
    });
  }

  return await api.get<Skyroom[]>(`skyroom/${queryParams.toString() ? "?" + queryParams.toString() : ""}`)
  .then(res => res.data)
  .catch(() => {return []});
};

export const getSkyroomById = async ({ id }: GetSkyroomParams): Promise<Skyroom | null> => {

  return await api.get(`/skyroom/${id}/`)
  .then(res => res.data)
  .catch(() => {return null});
};